import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const JMIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="JM" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#093"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#272727"
        stroke="#FECA00"
        strokeWidth={1.35}
        d="m-.07-.52 7.268 6L7.83 6l-.63.52-7.27 6-1.104.913V-1.433L-.07-.52Z"
      />
      <Path
        fill="#272727"
        stroke="#FECA00"
        strokeWidth={1.35}
        d="m16.082-.53-7.61 6-.671.53.672.53 7.609 6 1.093.862V-1.392l-1.093.862Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
